import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'utils/withRouter';
import { DropdownButton } from 'ui';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';

const TicketDropdown = styled(DropdownButton)`
  .ant-dropdown {
    text-transform: uppercase;
  }
`;

const TicketButtons = ({ id, history, intl }) => {
  const urlCreateTicket = `/ticket/new/${id?.replaceAll(':', '%3A')}`;

  const dropdownItemsTickets = [
    {
      text: intl.formatMessage({ id: 'ticket.GENERAL' }),
      onClick: () => history.push(`${urlCreateTicket}/type/general`),
    },
    {
      text: intl.formatMessage({ id: 'ticket.DIAGNOSTICS' }),
      onClick: () =>
        history.push(`${urlCreateTicket}/type/diagnostics`),
    },
  ];

  return (
    <TicketDropdown
      text={intl.formatMessage({ id: 'ticket.TITLE_CREATE' })}
      subItems={dropdownItemsTickets}
      onClick={() => history.push(`${urlCreateTicket}/type/general`)}
      disabled={!id}
      useBodyAsParent={true}
      dataTestId='btn-create-ticket'
    />
  );
};

TicketButtons.propTypes = {
  id: PropTypes.string,
  history: PropTypes.object.isRequired,
  intl: PropTypes.object,
};
export default injectIntl(withRouter(TicketButtons));
